export function stringifyPersonAccessRight(node: IPersonAccessRight) {
    return JSON.stringify({
      accountCode: node.account?.code ?? null,
      personIdentifier: node.person.immutableId,
      serviceCode: node.service.groupCode,
      personGroupSource: node.personGroupSource?.code ?? null,
      expirationDate: node.expirationDate
    })
  }